import React from "react";
import TableBadge from "@spark/ui-components/components/TanStackTable/components/TableBadge";
import TruncatedText from "@spark/ui-components/components/TanStackTable/components/TruncatedText";
import Icon from "@spark/ui-components/components/Icon";

const getStatusBadgeVariant = (value) => {
  const v = String(value || "")
    .trim()
    .toLowerCase();
  if (!v) return "default";
  if (
    v.includes("emit") ||
    v === "1" ||
    v.includes("ok") ||
    v.includes("sucesso")
  )
    return "success";
  if (v.includes("erro") || v.includes("falha")) return "danger";
  if (v.includes("pend")) return "warning";
  if (
    v.includes("process") ||
    v.includes("enviando") ||
    v.includes("andamento")
  )
    return "info";
  return "default";
};

export const getPedidosColumnsDepot = (onDuplicate) => [
  {
    id: "NumeroPedidoEmbarcador",
    header: "Nº do pedido do embarcador",
    accessorKey: "NumeroPedidoEmbarcador",
    size: 180,
    enableSorting: true,
    cell: ({ getValue }) => {
      const value = getValue();

      const handleCopy = async (event) => {
        event.stopPropagation();
        if (!value) return;

        try {
          await navigator.clipboard.writeText(String(value));
          const { notification } =
            await import("@spark/ui-components/utils/notification");
          notification.success("Copiado!");
        } catch {
        }
      };

      return (
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <TruncatedText value={value} maxLength={26} />
          <button
            type="button"
            onClick={handleCopy}
            title="Copiar número do pedido"
            style={{
              padding: "0",
              border: "none",
              background: "transparent",
              color: "#98a2b3",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              width: "20px",
              height: "20px",
              justifyContent: "center",
            }}
          >
            <Icon name="content-copy" size={14} />
          </button>
        </div>
      );
    },
  },

  {
    id: "nomeOperacao",
    header: "Nome Operação",
    accessorKey: "nomeOperacao",
    size: 200,
    enableSorting: true,
    cell: ({ getValue }) => <TruncatedText value={getValue()} maxLength={24} />,
  },
  {
    id: "tipoDeOperacao",
    header: "Codigo Operação",
    accessorKey: "tipoDeOperacao",
    size: 160,
    enableSorting: true,
    cell: ({ getValue }) => <TruncatedText value={getValue()} maxLength={18} />,
  },
  {
    id: "dataIntegracao",
    header: "Data Integração",
    accessorKey: "dataIntegracao",
    size: 150,
    enableSorting: true,
    cell: ({ getValue }) => <TruncatedText value={getValue()} maxLength={27} />,
  },
  {
    id: "statusPedidoEmissaoTMS",
    header: "Status Pedido TMS",
    accessorKey: "statusPedidoEmissaoTMS",
    size: 160,
    enableSorting: true,
    cell: ({ getValue }) => (
      <TableBadge
        label={String(getValue() || "")
          .replace(/\berro\b/gi, "Falha")
          .replace(/\bERROR\b/gi, "Falha")}
        variant={getStatusBadgeVariant(getValue())}
        size="sm"
      />
    ),
  },
  {
    id: "Acoes",
    header: "Ações",
    size: 120,
    enableSorting: false,
    cell: ({ row }) => {
      return (
        <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
          <button
            onClick={(e) => {
              e.stopPropagation();
              if (onDuplicate) {
                onDuplicate(row?.original);
              }
            }}
            style={{
              padding: "4px 12px",
              fontSize: "12px",
              border: "1px solid #007bff",
              background: "white",
              color: "#007bff",
              borderRadius: "4px",
              cursor: "pointer",
            }}
            title="Duplicar Pedido"
          >
            Duplicar Pedido
          </button>
        </div>
      );
    },
  },
];